module.exports = __webpack_public_path__ + "media/images/customer-location-c03acecc9c6026547015f9d97d959c7e.png";